import { z, ZodError } from 'zod'
import { oocApi } from '@/lib/apiClient'
import { oocUrls } from '@/lib/urlBuilder'
import { normalizeZodError } from '@/lib/apiErrors'

export type OtpChannel = 'SMS' | 'EMAIL'

export const RequestOtpRequestSchema = z.object({
	channel: z.enum(['SMS', 'EMAIL']),
	identifier: z.string().min(1),
	locationId: z.number().int().positive(),
})
export type RequestOtpRequest = z.infer<typeof RequestOtpRequestSchema>

export const RequestOtpResponseSchema = z.object({
	message: z.string(),
	correlationId: z.string().uuid(),
	metadata: z.object({
		otpExpiryInMinutes: z.number(),
	}),
})
export type RequestOtpResponse = z.infer<typeof RequestOtpResponseSchema>

export const VerifyOtpRequestSchema = z.object({
	channel: z.enum(['SMS', 'EMAIL']),
	identifier: z.string().min(1),
	otp: z.string().regex(/^\d{6}$/, 'OTP must be a 6-digit code'),
	correlationId: z.string(),
})
export type VerifyOtpRequest = z.infer<typeof VerifyOtpRequestSchema>

export const VerifyOtpResponseSchema = z.object({
	accessToken: z.string(),
})
export type VerifyOtpResponse = z.infer<typeof VerifyOtpResponseSchema>

export function requestOtp(body: RequestOtpRequest): Promise<RequestOtpResponse> {
	return oocApi
		.post<RequestOtpRequest, unknown>(oocUrls.requestOtp(), body)
		.then((raw) => {
			const parsed = RequestOtpResponseSchema.parse(raw)
			return parsed
		})
		.catch((err: unknown) => {
			if (err instanceof ZodError) throw normalizeZodError(err)
			throw err
		})
}

export function verifyOtp(body: VerifyOtpRequest): Promise<VerifyOtpResponse> {
	return oocApi
		.post<VerifyOtpRequest, unknown>(oocUrls.verifyOtp(), body)
		.then((raw) => {
			const parsed = VerifyOtpResponseSchema.parse(raw)
			return parsed
		})
		.catch((err: unknown) => {
			if (err instanceof ZodError) throw normalizeZodError(err)
			throw err
		})
}
